// extracted by mini-css-extract-plugin
export default {"heading":"Club_heading__XCvjv","h4":"Club_h4__Dma1u","h5":"Club_h5__eWs+l","h2":"Club_h2__aN-Oo","ul":"Club_ul__kbIYY"};